import { render, staticRenderFns } from "./CenterStatusFlag.vue?vue&type=template&id=659e9ca2&"
import script from "./CenterStatusFlag.vue?vue&type=script&lang=js&"
export * from "./CenterStatusFlag.vue?vue&type=script&lang=js&"
import style0 from "./CenterStatusFlag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
